import { MetricsRow, MetricsSpace } from "app/pages/keyword-analysis/TotalTrafficPage/StyledComponents";
import DurationService from "app/services/DurationService";

import {
    SearchOverviewTopOrganicKeywords,
    SearchOverviewTopPaidKeywords,
} from "../SearchOverviewTraffic/SearchOverviewTrafficTables";
import { MetricContainer } from "../SearchOverviewTraffic/StyledComponent";

const metricHeight = "330px";
const metricWidth = "33.3%";
const metricMarginTop = "24px";
const bigMetricWidth = "50%";

export const SearchOverviewTrafficSingle = (props) => {
    const { country, isWWW, duration, key, webSource } = props.params;
    const { from, to, isWindow } = DurationService.getDurationData(duration).forAPI;
    const queryParams = {
        country,
        from,
        includeSubDomains: isWWW === "*",
        isWindow,
        keys: key,
        to,
        webSource,
        timeGranularity: "Monthly",
    };
    return (
        <MetricsRow marginTop={metricMarginTop}>
            <MetricContainer
                height={metricHeight}
                width={bigMetricWidth}
            >
                <SearchOverviewTopOrganicKeywords
                    queryParams={queryParams}
                    routingParams={props.params}
                />
            </MetricContainer>
            <MetricsSpace />
            <MetricContainer
                height={metricHeight}
                width={bigMetricWidth}
            >
                <SearchOverviewTopPaidKeywords
                    queryParams={queryParams}
                    routingParams={props.params}
                />
            </MetricContainer>
        </MetricsRow>
    );
};
